/* reorder-flow.js \u2014 instrument + flow controller (STAGING). Depends on window.ReorderAPI. */
/* === Custom Instrument Stack v2.0 =========================================
   Spec: Document Control > Artifacts > 2026-09-23_SPEC_CustomInstrumentStack_v02_CL.md
   GENERATED by build_reorder_align.py from instrument_v2_data.py - do not hand-edit.
   sections/intake-flow.liquid is generated from the same source, which is what
   keeps an intake and a reorder for the same pet on one ruler.

   15 clinical measures across 6 conditions, keyed by their CRM API names. The
   ANCHORS are verbatim from the canonical Zoho Form "2026-01-04 Custom Intake
   Form" and are identical on both forms; only the question register differs
   (intake asks the baseline, reorder asks the re-measure). That is what makes a
   3 in May comparable to a 3 in September. Do not reword or shorten.

   Every clinical slider is 0-5 (0 = none) where 5 is WORST. Satisfaction (overall_response)
   is the opposite, 5 = BEST, and renders in its own block so the two are never
   read as one scale. Selection is driven by the pet's CONDITION FLAGS, never by
   which fields the previous order happened to carry.

   Condition labels are the softened Support-style ones, not the canonical disease
   names, per Brand Guide Sec 12.3. The label is cosmetic - the slider value and
   its CRM field are what get stored - so softening it costs no comparability. */
var RR_CONDITIONS = [
  { key:'arthritis', label:'Arthritis / Mobility / Inflammation' },
  { key:'pain',      label:'Pain' },
  { key:'anxiety',   label:'Anxiety' },
  { key:'seizures',  label:'Seizures' },
  { key:'cancer',    label:'Cancer' },
  { key:'gi',        label:'IBD / IBS / Gastrointestinal Disease' },
  { key:'skin',      label:'Skin Disease / Allergies' },
  { key:'renal',     label:'Renal (Kidney) / Urinary Disease' },
  { key:'cardiac',   label:'Cardiac Disease' },
  { key:'other',     label:'Other' }
];
var RR_BATTERY = {
  arthritis: [
    { key:'Mobility_Overall', q:'Please rate their current level of overall mobility restriction',
      a:'1 means small restrictions to your pet\u2019s range of motion, 5 means your pet can barely move and/or bend their joints without serious stiffness or pain' },
    { key:'Mobility_Prevent_Activity', q:'How much does their current mobility restriction prevent activities like long walks?',
      a:'1 means they struggle with only a few activities, or they only sometimes have mobility issues. 5 means the problem is constant and prevents most daily activities' },
    { key:'Mobility_Pain', q:'How much pain is the mobility issue causing at this time?',
      a:'1 would mean small physical indications like limping, 5 indicates regular whimpering, panting, aggressive behavioral changes, excessive licking, or other abnormal behavior' }
  ],
  pain: [
    { key:'Pain_Overall', q:'How have their pain symptoms been in the last couple weeks?',
      a:'1 would mean small physical indications like limping, 5 indicates regular whimpering, panting, aggressive behavioral changes, excessive licking, or other abnormal behavior' },
    { key:'Pain_Prevent_Activities', q:'How much does their current level of pain prevent daily activities?',
      a:'1 means they struggle with only a few activities, or they only sometimes have issues. 5 means the problem is constant and prevents most daily activities' },
    { key:'Pain_Daily_Comfort', q:'How much discomfort do they show on an average day now?',
      a:'1 means they settle and rest comfortably most of the day, 5 means they are restless, panting or shifting position constantly' }
  ],
  anxiety: [
    { key:'Anxiety_Overall', q:'Please rate your pet\u2019s current overall anxiety level',
      a:'1 is low and 5 is high anxiety' },
    { key:'Anxiety_Trigger_Human', q:'Understanding that things can change, at this time, how much is their anxiety triggered by other humans or pets?',
      a:'' },
    { key:'Anxiety_Trigger_Events', q:'How much is their current anxiety triggered by events like thunder, fireworks, trips to the vet, separation, etc?',
      a:'' }
  ],
  seizures: [
    { key:'Seizures_Frequency', q:'How frequently have they had seizures over the last few weeks?',
      a:'1 indicates sporadic and unpredictable, 5 means multiple times per day' },
    { key:'Seizures_Length', q:'How long have recent seizures lasted?',
      a:'1 is a few seconds, 5 is multiple minutes' },
    { key:'Seizures_Postictal', q:'How long is their current postictal period (recovery time post seizure)?',
      a:'1 indicates a matter of minutes, 5 means the better part or more of a day' }
  ],
  cancer: [
    { key:'Cancer_Slider', q:'Understanding that things change over time, how much is the cancer now affecting their quality of life?',
      a:'1 indicates they are coping well with only minor symptoms, 5 indicates serious complications for appetite, mood, energy, etc' }
  ],
  gi: [
    { key:'GI_Inflammation', q:'How much is their digestive condition affecting them at this time?',
      a:'1 means occasional soft stool or mild upset, 5 means frequent vomiting or diarrhea, cramping, or visible weight loss' },
    { key:'Appetite', q:'How much is their appetite affected right now?',
      a:'1 means they eat normally most days, 5 means they regularly refuse food or have to be coaxed to eat' }
  ],
  skin: [],
  renal: [],
  cardiac: [],
  other: []
};
/* Free-text follow-ups that belong to a condition. */
var RR_COND_NOTES = {
  cancer:  { key:'cancer_details', label:'Are there any updates about their cancer that we should know?' },
  cardiac: { key:'cardiac_info', label:'Any updates about their cardiac condition we should know?' },
  gi:      { key:'gi_notes', label:'Anything else about their digestion we should know?' },
  other:   { key:'other_conditions', label:'Are there new medical conditions affecting your pet we should know about?' }
};

/* Dose picklist (spec s3.1). A picklist, never free text - a type-ahead is not a
   picklist (spec s7.7). These strings are copied VERBATIM from the Zoho
   Custom_Orders.Current_Dose picklist, read 2026-09-24. Zoho drops a value that is
   not on the picklist without raising an error, so "0.10 mL" or "1.00 mL" would be
   lost in silence. Do not reformat, pad or re-derive them. */
var RR_DOSES = [
  '0.05 mL','0.1 mL','0.15 mL','0.2 mL','0.25 mL','0.3 mL','0.35 mL','0.4 mL',
  '0.45 mL','0.5 mL','0.55 mL','0.6 mL','0.65 mL','0.7 mL','0.75 mL','0.8 mL',
  '0.85 mL','0.9 mL','0.95 mL','1.0 mL',
  'Auto-Ship Continue Current Dose',
  'As Directed by Doctor'
];

/* === instrument-v1.json (inlined) ========================================= */
var INSTRUMENT = {
  fields: [
    { key:'formula_intent', label:'Do you want the same formula for {p}?', type:'single', required:true,
      help:'If nothing has changed, we reorder exactly what we made last time.',
      options:[{value:'same',label:'Same formula'},{value:'changed',label:'Something has changed',reveals:'formula_change_note'}] },
    { key:'formula_change_note', label:'What has changed for {p}?', type:'textarea',
      requiredWhen:{formula_intent:'changed'},
      placeholder:'For example, a new symptom, a new medication, or a note from your vet.',
      help:'Please detail any changes in {p}\u2019s needs for our expert veterinary cannabinoid formulation team. Add as much information as you can.' },
    { key:'weight', label:'What does {p} weigh now?', type:'number', unit:'lb', required:true,
      help:'A current weight helps us keep the formulation right for {p}.', prefill_from:'weight' },
    /* Dose is asked before the battery so the clinical answers sit together. */
    { key:'current_dose', label:'How much Custom Right:Ratio tincture do you give per dose?', type:'select', required:true,
      help:'What is the current dose your pet takes each time?', options:RR_DOSES, prefill_from:'current_dose' },
    /* Condition checklist + the full battery for every ticked condition. Driven by the
       pet\u2019s condition flags, NOT by which fields the last order carried (spec s4). */
    { key:'pro_domains', type:'instrument', required:true },
    { key:'side_effects_since_last_order', label:'Any side effects since the last order?', type:'single', required:true,
      options:[{value:'none',label:'None'},{value:'some',label:'Some',reveals:'side_effect_details'}] },
    { key:'side_effect_details', label:'Tell us what you noticed', type:'textarea',
      requiredWhen:{side_effects_since_last_order:'some'},
      placeholder:'For example, more sleepy than usual, or an upset stomach.',
      help:'Plain language is fine. This goes straight to the person who formulates for {p}.' },
    { key:'new_meds', label:'Any new medications or supplements in the last year?', type:'single', required:true,
      options:[{value:'no',label:'No'},{value:'yes',label:'Yes',reveals:'new_meds_list'}] },
    { key:'new_meds_list', label:'What are they taking?', type:'textarea',
      requiredWhen:{new_meds:'yes'}, placeholder:'Name and dose if you have it.',
      help:'Anything they take regularly, including supplements.' },
    { key:'new_vet', label:'Are you seeing a new vet?', type:'single', required:true,
      options:[{value:'no',label:'No'},{value:'yes',label:'Yes',reveals:'new_vet_name'}] },
    { key:'new_vet_name', label:'Which practice?', type:'text',
      requiredWhen:{new_vet:'yes'}, placeholder:'Clinic or practice name',
      help:'This reaches the team as a note. To change the vet on {p}\u2019s record, edit the vet card above.' },
    /* Overall Response \u2014 single-tap satisfaction (Cathy's copy, 2026-08-02).
       STORED VALUES are the STABLE numeric codes (Custom_Orders.Overall_Response),
       5 = best; display labels are pet-parent voice and may be retitled without
       breaking historical comparability. Rendered ascending 1..5. Routing:
       5/4 -> review/story ask, 1 -> personal follow-up. Sits right after the
       dose/side-effects questions with a titration reminder (placement per Cathy). */
    { key:'overall_response', label:'How is {p} doing on the Custom formula?', type:'single', required:true,
      help:'A quick reminder: your Custom formula is designed to be adjusted as {p}\u2019s needs change. If it\u2019s been a while since your last check-in, this is a great moment to tell us how things are going.',
      options:[
        {value:'1',label:'I have yet to see a change in {p}'},
        {value:'2',label:'I\u2019m starting to notice a difference'},
        {value:'3',label:'{p}\u2019s symptoms have noticeably improved'},
        {value:'4',label:'It\u2019s changed {p}\u2019s life for the better'},
        {value:'5',label:'It\u2019s given me so much more quality time with {p}'}
      ] },
    /* Order details - REQUIRED (Charles, 2026-09-18). Reorders were reaching Zoho
       with no size, count or payment method, so staff had to ask before invoicing.
       Size and count prefill from the last order where they map cleanly; the
       customer still sees and confirms them. Payment is always an explicit pick.
       orderField:true = hidden on the autoship check-in (that order already has them). */
    { key:'reorder_types', label:'What do you need to reorder?', type:'multi', required:true, orderField:true,
      help:'Choose everything you need on this order.',
      options:[
        {value:'Custom Tincture',label:'Custom Tincture'},
        {value:'Topical Balm',label:'Topical Balm'},
        {value:'Booster',label:'Booster'},
        {value:'Hemp Products',label:'A Right:Ratio Formulary bottle (A:1, Ax:1, C:1, F:1 or N:1)'}
      ] },
    { key:'tincture_qty', label:'How many Custom tincture bottles?', type:'single', orderField:true,
      requiredWhen:{reorder_types:'Custom Tincture'},
      options:[{value:'1',label:'1'},{value:'2',label:'2'},{value:'3',label:'3'}] },
    { key:'tincture_size', label:'Bottle size for this Custom tincture', type:'single', orderField:true,
      requiredWhen:{reorder_types:'Custom Tincture'},
      help:'Set to the size from your last order. Change it if you need to.',
      options:[
        {value:'Standard 1 oz (29.5 mL)',label:'Standard 29.5 mL (1 oz)'},
        {value:'New - 2 oz (60 mL) with 10% off',label:'New - 60 mL (2 oz) - 10% off first bottle, excludes shipping'}
      ] },
    { key:'tincture_mixed', label:'Do you need different sizes or formulas on this order?', type:'single', orderField:true,
      requiredWhen:{reorder_types:'Custom Tincture'},
      help:'For example, 1 standard 29.5 mL and 1 60 mL bottle.',
      options:[{value:'no',label:'No, all the same'},{value:'yes',label:'Yes',reveals:'tincture_details'}] },
    { key:'tincture_details', label:'Tell us exactly what you need', type:'textarea', orderField:true,
      requiredWhen:{tincture_mixed:'yes'},
      placeholder:'Sizes and formulas for each bottle.' },
    { key:'topical_qty', label:'How many Topical Balm jars?', type:'single', orderField:true,
      requiredWhen:{reorder_types:'Topical Balm'},
      options:[{value:'1',label:'1'},{value:'2',label:'2'},{value:'3',label:'3'}] },
    { key:'booster_qty', label:'How many Boosters?', type:'single', orderField:true,
      requiredWhen:{reorder_types:'Booster'},
      options:[{value:'1',label:'1'},{value:'2',label:'2'},{value:'3',label:'3'}] },
    { key:'booster_size', label:'Bottle size for the Booster', type:'single', orderField:true,
      requiredWhen:{reorder_types:'Booster'},
      options:[
        {value:'Standard 29.5 mL (1 oz)',label:'Standard 29.5 mL (1 oz)'},
        {value:'New - 60 mL (2 oz) with 10% off',label:'New - 60 mL (2 oz) - 10% off first bottle, excludes shipping'}
      ] },
    { key:'booster_details', label:'Anything we should know about the Booster?', type:'text', optional:true, orderField:true,
      requiredWhen:{reorder_types:'Booster'}, placeholder:'Optional' },
    /* Formulary bottles. This used to be a separate "would you like to add one?" question
       that duplicated the reorder_types tick and wrote the same three fields. Never write
       the word used by the CRM field names into customer copy (Brand Guide Sec 12.5). */
    { key:'hemp_product', label:'Which Right:Ratio Formulary formula?', type:'single', orderField:true,
      requiredWhen:{reorder_types:'Hemp Products'},
      options:[
        {value:'A:1',label:'A:1 | Mobility & Joint Support'},
        {value:'Ax:1',label:'Ax:1 | Calming & Stress Support'},
        {value:'C:1',label:'C:1 | Cellular Support'},
        {value:'N:1',label:'N:1 | Neurologic Support'},
        {value:'F:1',label:'F:1 | Feline Elixir Plus (cats only)'}
      ] },
    { key:'hemp_qty', label:'How many Formulary bottles?', type:'single', orderField:true,
      requiredWhen:{reorder_types:'Hemp Products'},
      options:[{value:'1',label:'1'},{value:'2',label:'2'}] },
    { key:'addon_for', label:'Who is it for?', type:'text', optional:true, orderField:true,
      requiredWhen:{reorder_types:'Hemp Products'},
      placeholder:"Your other pet\u2019s name, if it is not for {p}" },
    /* Autoship. Canonical reorder form frames this as a benefit, not a setting. */
    { key:'order_autoship', label:'Auto-Shipping', type:'single', required:true, orderField:true,
      help:'Save time so you never miss a dose. Nothing due until you are ready. Set to what is on file - change it if you need to.',
      options:[{value:'On',label:'On'},{value:'Off',label:'Off'}] },
    { key:'payment_option', label:'How will you pay?', type:'single', required:true, orderField:true,
      help:'Payment is by Venmo, PayPal, Zelle, or Apple Cash. We do not accept credit cards.',
      options:[{value:'Venmo',label:'Venmo'},{value:'Paypal',label:'PayPal'},{value:'Zelle',label:'Zelle'},{value:'Apple Cash',label:'Apple Cash'}] },
    /* Formulary add-on (2026-09-20). A handful of Custom customers order a ready-made
       bottle for a SECOND pet on the same order. They used to ask in the old form's
       notes box, and roughly half those requests never reached the structured CRM
       fields - someone had to read the note and retype it. The fields already exist
       on Custom_Orders (Order_hemp_products / Hemp_products / Hemp_quantity) and the
       values below match those picklists exactly, so nothing has to be mapped.
       Hidden until the customer answers yes: the renderer drops any field whose
       requiredWhen trigger is unmet, so the other several hundred customers never
       see it. Never write the word used by the CRM field names into customer copy
       (Brand Guide Sec 12.5). */
  ]
};

/* === reorder-flow.js (inlined) ============================================ */
(function(){
  var root = document.documentElement;
  var screenEl = document.getElementById('screen');
  var S = null;               // session
  var forceErr = false;

  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function h(html){ screenEl.innerHTML = html; }
  function fill(t){ return String(t).replace(/\{p\}/g, S && S.patient ? esc(S.patient.name) : 'your pet'); }
  function deriveAge(dob){ if(!dob) return null; var d=new Date(dob), n=new Date();
    var a=n.getFullYear()-d.getFullYear(); var m=n.getMonth()-d.getMonth();
    if(m<0||(m===0&&n.getDate()<d.getDate())) a--; return a; }
  // A bare YYYY-MM-DD is parsed as UTC midnight, which prints the previous day in US time
  // zones (a 1 May birthday showed as 30 April). Read date-only values at local noon.
  function fmtDate(dob){ if(!dob) return ''; var d=String(dob); if(/^\d{4}-\d{2}-\d{2}$/.test(d)) d+='T12:00:00'; return new Date(d).toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'}); }
  function effectiveDOB(){ var c=S.corrections.filter(function(x){return x.entity==='patient'&&x.field==='dob';})[0]; return c?c.to:(S.patient?S.patient.date_of_birth:null); }
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

  /* ---------- session bootstrapping per entry mode ---------- */
  function newSession(mode, extra){
    S = { mode:mode, token:null, parent:null, shipping:null, patient:null, context:null,
      instrument_version:'2.0',   // stamped on every submission (spec s5)
      request:null, observation:{}, corrections:[], _forceSubmitError:forceErr };
    if (extra) for (var k in extra) S[k]=extra[k];
    return S;
  }
  function hydrate(ctx){
    ctx = JSON.parse(JSON.stringify(ctx)); // clone so corrections never mutate the shared fixtures
    S.parent = ctx.parent; S.shipping = ctx.shipping; S.patient = ctx.patient; S.context = ctx.context;
    S.request = { bottle_size: ctx.context.bottle_size, bottles_ordered: ctx.context.bottles_ordered, autoship: ctx.context.autoship };
    S.observation = { weight: '' };
    /* Conditions come from the pet\u2019s flags, so a pet keeps answering its battery
       forever whether or not last time\u2019s order happened to carry those fields.
       ctx.context.conditions is the server half (in build); until it lands, infer
       from the legacy domains list so the page still works. */
    S.observation.conditions = (function(){
      var c = ctx.context || {};
      if (Object.prototype.toString.call(c.conditions) === '[object Array]') return c.conditions.slice();
      var out = [], seen = {};
      (c.domains || []).forEach(function(d){
        for (var ck in RR_BATTERY){
          if (!RR_BATTERY.hasOwnProperty(ck)) continue;
          for (var i=0;i<RR_BATTERY[ck].length;i++){
            if (RR_BATTERY[ck][i].key === d.key && !seen[ck]){ seen[ck]=1; out.push(ck); }
          }
        }
      });
      return out;
    })();
    /* The dose the pet is on right now, so the customer confirms it rather than
       re-picking it. The server sends this as `last_dose_display`; this line read
       `current_dose`, a key that has never been on the payload, so the select came up
       empty on every reorder and the customer chose from scratch - with '0.05 mL', the
       floor, sitting first in the list. Legacy records also hold the spaceless form
       ('0.5mL'), which matches no option, so normalise before matching.
       (2026-09-24, after order 29633 arrived at a tenth of its prior dose.) */
    (function(){
      var c = ctx.context || {};
      var t = String(c.last_dose_display || c.current_dose || '').trim();
      if (!t) return;
      if (RR_DOSES.indexOf(t) < 0){
        var m = t.match(/^(\d*\.?\d+)\s*m\s*l$/i);
        if (m){
          var n = parseFloat(m[1]);
          var cand = (n >= 1 ? n.toFixed(1) : String(n)) + ' mL';
          if (RR_DOSES.indexOf(cand) >= 0) t = cand;
        }
      }
      if (RR_DOSES.indexOf(t) >= 0) S.observation.current_dose = t;
    })();
    (function(){
      var c = ctx.context || {}, po = c.prior_order || {};
      var bs = String(po.bottle_size || c.bottle_size || ''), bo = String(po.bottles_ordered || c.bottles_ordered || '');
      S.observation.order_autoship = c.autoship ? 'On' : 'Off';
      /* Prefill the tincture line from the last order, in Custom_Bottle_Size_Options
         values. reorder_types is deliberately NOT prefilled - what is on this order is
         the one thing we want the customer to choose rather than confirm. The defaults
         are stashed so ticking Custom Tincture later still gets them. */
      S._orderPrefill = {};
      if (/60\s*mL|2\s*oz/i.test(bs)) S._orderPrefill.tincture_size = 'New - 2 oz (60 mL) with 10% off';
      else if (/29\.5|1\s*oz/i.test(bs)) S._orderPrefill.tincture_size = 'Standard 1 oz (29.5 mL)';
      if (/^[123]$/.test(bo)) S._orderPrefill.tincture_qty = bo;
      for (var pk in S._orderPrefill) if (S._orderPrefill.hasOwnProperty(pk)) S.observation[pk] = S._orderPrefill[pk];
      // Last payment method, pre-selected; the customer sees it and can change it (2026-09-19).
      var pm = String(c.payment_option || ''), PM = { 'venmo':'Venmo', 'paypal':'PayPal', 'zelle':'Zelle', 'apple cash':'Apple Cash' };
      if (PM[pm.toLowerCase()]) S.observation.payment_option = PM[pm.toLowerCase()];
    })();
    S.vet = ctx.vet ? { contactId: ctx.vet.contactId||'', accountId: ctx.vet.accountId||'', name: ctx.vet.name||'', clinic: ctx.vet.clinic||'', isNew:false, changed:false }
                    : { contactId:'', accountId:'', name:'', clinic:'', isNew:false, changed:false };
    S._vetEdit = false; S._vetNew = false;
  }
  // ---- resume + failure handling (2026-09-19) ----
  var PKEY = 'rrReorderPet';
  function _petGet(){ try { return window.sessionStorage.getItem(PKEY); } catch(e){ return null; } }
  function _petSet(v){ try { if(v) window.sessionStorage.setItem(PKEY, v); else window.sessionStorage.removeItem(PKEY); } catch(e){} }
  function _expired(err){ return err && err.code === 'SESSION_EXPIRED'; }
  function loadPet(id, name){
    renderLoading('Loading '+(name?esc(name)+'\u2019s':'your')+' formula');
    ReorderAPI.getReorderContext(id).then(function(ctx){ _petSet(id); hydrate(ctx); renderConfirm(); },
      function(err){
        _petSet(null);
        if(_expired(err)) return startCold('For your security, please confirm your email again.');
        renderLoadError(function(){ loadPet(id, name); });
      });
  }
  function renderLoadError(retry){
    h('<div class="card"><div class="card-b"><div class="band" style="color:var(--crit);border-color:var(--crit)">'
      + '<div class="dot" style="background:var(--crit)"></div><div><b>We could not load your pet\u2019s details.</b> Please try again. If it keeps happening, call 310-600-7347.</div></div>'
      + '<button class="cta" id="retryLoad">Try again</button>'
      + '<button class="linkback" id="restart">Start over</button></div></div>');
    document.getElementById('retryLoad').onclick = retry;
    document.getElementById('restart').onclick = function(){ startCold(); };
  }
  function correct(entity, field, from, to, scope){
    S.corrections = S.corrections.filter(function(c){return !(c.entity===entity&&c.field===field);});
    if (String(from)!==String(to)){
      var c = {entity:entity, field:field, from:from, to:to};
      // scope='permanent' on a shipping change means the customer MOVED: the service
      // updates the address on file instead of recording a one-time ship-to and
      // sending this and every future reorder to review (Charles, 2026-09-22).
      if (scope) c.scope = scope;
      S.corrections.push(c);
    }
  }
  function isCorrected(entity, field){ return S.corrections.some(function(c){return c.entity===entity&&c.field===field;}); }

  /* ================= ENTRY POINTS ================= */
  function startKeyed(token){
    newSession('keyed', {token:token});
    renderLoading('Loading your reorder');
    ReorderAPI.resolveToken(token).then(function(ctx){
      if (ctx.kind==='check_in'){ hydrate(ctx); renderCheckIn(); return; }
      hydrate(ctx); renderConfirm();
    }, function(err){ renderTokenError(err.code); });
  }
  // End-to-end entry: show the reorder email that carries the magic link, then
  // the link click resolves the token and prepopulates the confirm screen.
  function startFromEmail(token){
    newSession('keyed', {token:token});
    renderLoading('Loading');
    ReorderAPI.resolveToken(token).then(function(ctx){
      if (ctx.kind==='check_in'){ hydrate(ctx); renderCheckIn(); return; }
      S._pendingCtx = ctx; renderEmailEntry(ctx);
    }, function(err){ renderTokenError(err.code); });
  }
  function renderEmailEntry(ctx){
    var name = ctx.patient.name, first = ctx.parent.first_name;
    var topical = ctx.context.product_type === 'topical';
    h('<p class="emailcap">Preview of the reorder email</p>'
      + '<div class="email"><div class="meta">'
        + '<span class="from">Right:Ratio &lt;info@rightratio.com&gt;</span>'
        + '<span>To ' + esc(first) + ' ' + esc(ctx.parent.last_name) + '</span>'
        + '<span class="subj">Time to reorder ' + esc(name) + '\u2019s '+(topical?'topical':'formula')+'</span>'
      + '</div><div class="body">'
        + '<p>Hi ' + esc(first) + ',</p>'
        + '<p>It\u2019s time to reorder ' + esc(name) + '\u2019s ' + esc(ctx.context.product_line) + '. The button below opens a secure link to confirm the details and place the reorder. No password needed, and the link is just for you.</p>'
        + '<button class="cta" id="magic" style="margin-top:.3rem">Start ' + esc(name) + '\u2019s reorder</button>'
        + '<p style="color:var(--muted);font-size:.85rem;margin-top:.2rem">This link expires in 7 days. If you did not expect this, you can ignore it.</p>'
      + '</div></div>'
      + '<p class="muted-note ground">Prototype: the button stands in for the magic link in the real email.</p>');
    document.getElementById('magic').onclick = function(){
      renderLoading('Opening your secure link');
      setTimeout(function(){ hydrate(S._pendingCtx); renderConfirm(); }, 550);
    };
  }
  function startCold(msg){ var keep = S && S._resume; newSession('cold'); if(keep) S._resume = keep; renderColdEmail(typeof msg === 'string' ? msg : undefined); }
  function startCheckIn(token){
    newSession('keyed', {token:token});
    renderLoading('Loading your check-in');
    ReorderAPI.resolveToken(token).then(function(ctx){ hydrate(ctx); renderCheckIn(); },
      function(err){ renderTokenError(err.code); });
  }

  /* ================= SCREENS ================= */
  function renderLoading(msg){
    h('<div class="card"><div class="center"><div class="spinner" role="status" aria-label="Loading"></div>'
      + '<p class="lede">'+esc(msg)+'</p></div></div>');
  }

  function renderTokenError(code){
    var expired = code==='TOKEN_EXPIRED';
    h('<div class="card"><div class="card-h"><div class="eyebrow">Reorder</div>'
      + '<h1 class="title">'+(expired?'That link has expired':'We couldn\u2019t open that link')+'</h1>'
      + '<p class="lede">'+(expired
          ? 'Reorder links expire for your security. You can pick up right where you left off by confirming your email.'
          : 'The link may have been cut off in the email. You can continue by confirming your email instead.')
      + '</p></div><div class="card-b"><button class="cta" id="toCold">Continue with email</button></div></div>');
    document.getElementById('toCold').onclick = startCold;
  }

  /* ---- Mode B: cold arrival ---- */
  function renderColdEmail(err){
    h('<div class="hero">'
      + '<h1 class="hero-mark">Reorder your pet\u2019s Custom formula</h1>'
      + '<label class="hero-label" for="em">Your email address</label>'
      + '<input id="em" class="hero-input" type="email" inputmode="email" autocomplete="email" placeholder="Enter the email on your account" value="" />'
      + (err?'<div class="hero-err">'+esc(err)+'</div>':'')
      + '<button class="cta" id="send">Find my pets</button>'
      + '<p class="muted-note ground" style="margin-top:.7rem">We\u2019ll send a six-digit code to confirm it\u2019s you.</p>'
      + '</div>');
    document.getElementById('send').onclick = function(){
      var email = document.getElementById('em').value;
      email = String(email || '').trim();
      if(!email || email.indexOf('@')<0){ return renderColdEmail('Please enter a valid email address.'); }
      S.email = String(email).trim(); renderLoading('Sending your code');
      ReorderAPI.requestCode(S.email).then(function(r){ S._devCode = r && r._devCode; renderColdCode(); },
        function(){ renderColdEmail('We could not send your code just now. Please check the email address and try again.'); });
    };
  }
  function renderColdCode(err){
    h('<div class="card"><div class="card-h"><div class="eyebrow">Reorder</div>'
      + '<h1 class="title">Enter your code</h1>'
      + '<p class="lede">We sent a six-digit code to '+esc(S.email)+'. It expires in 10 minutes.</p></div>'
      + '<div class="card-b"><label class="fld" for="code">Six-digit code'
      + '<input id="code" inputmode="numeric" autocomplete="one-time-code" maxlength="6" placeholder="123456" value="'+esc(S._devCode||'')+'" /></label>'
      + (err?'<div class="band" style="color:var(--crit);border-color:var(--crit)"><div class="dot" style="background:var(--crit)"></div>'+esc(err)+'</div>':'')
      + '<button class="cta" id="verify">Confirm code</button>'
      + '<button class="linkback" id="back">Use a different email</button>'
      + (S._devCode?'<p class="muted-note" style="text-align:left">Staging only: no email is sent yet, so your code (<b>'+esc(S._devCode)+'</b>) is filled in for you.</p>':'')+'</div></div>');
    document.getElementById('verify').onclick = function(){
      var code = document.getElementById('code').value;
      renderLoading('Confirming');
      ReorderAPI.verifyCode(S.email, code).then(function(res){
          var pend = S._resume;
          if(pend && pend.patient && (res.patients||[]).some(function(p){ return String(p.id)===String(pend.patient.id); })){
            pend.email = S.email; S = pend; S._resume = null; _petSet(S.patient.id); renderReview(); return;
          }
          renderPicker(res.patients);
        },
        function(err){
          var c = err && err.code;
          if(c === 'CODE_EXPIRED' || c === 'CODE_NOT_FOUND' || c === 'TOO_MANY_ATTEMPTS')
            return renderColdCode('That code has expired. Tap "Use a different email" to send a new one.');
          renderColdCode('That code didn\u2019t match. Check the latest email and try again.');
        });
    };
    document.getElementById('back').onclick = startCold;
  }
  function renderPicker(patients){
    patients = patients || [];
    // 0 pets: the email matched no customer (e.g. a typo). Show a clear dead-end recovery,
    // not the empty "which pet?" screen.
    if(!patients.length){
      h('<div class="card"><div class="card-h"><div class="eyebrow">Reorder</div>'
        + '<h1 class="title">We couldn\u2019t find your account</h1>'
        + '<p class="lede">We don\u2019t see a Custom order under <b>'+esc(S.email)+'</b>. Double-check the email you used when you first ordered - or start a new intake.</p></div>'
        + '<div class="card-b"><button class="cta" id="reEmail">Try a different email</button>'
        + '<button class="linkback" id="toIntake" style="margin-top:.6rem">Start a new intake</button></div></div>');
      var re=document.getElementById('reEmail'); if(re) re.onclick=startCold;
      var ti=document.getElementById('toIntake'); if(ti) ti.onclick=function(){ window.location.href='/pages/custom-intake'; };
      return;
    }
    // exactly 1 pet: no need to pick \u2014 load it straight away.
    if(patients.length===1){
      var only=patients[0];
      loadPet(only.id, only.name);
      return;
    }
    var rows = patients.map(function(p,i){
      return '<button class="choice" style="display:block;width:100%;text-align:left;margin:0 0 .5rem;padding:.8rem .9rem" data-id="'+esc(p.id)+'">'
        + '<span style="font-weight:700;font-size:1rem">'+esc(p.name)+'</span>'
        + '<span class="sub" style="display:block;color:var(--muted);font-size:.84rem;margin-top:.15rem">'+esc(p.disambiguator)+'</span></button>';
    }).join('');
    h('<div class="card"><div class="card-h"><div class="eyebrow">Reorder</div>'
      + '<h1 class="title">Which pet is this reorder for?</h1>'
      + '<p class="lede">We found more than one pet on your account. Choose the one you\u2019re reordering for.</p></div>'
      + '<div class="card-b">'+rows+'</div></div>');
    Array.prototype.forEach.call(screenEl.querySelectorAll('[data-id]'), function(btn){
      btn.onclick = function(){
        loadPet(btn.getAttribute('data-id'), btn.querySelector('span').textContent);
      };
    });
  }

  /* ---- prior order: read-only (Charles, 2026-09-22) ----
     One real order - the newest invoiced one - so nothing here is editable; changes
     for this order are made under This reorder. Rows with no value are left out
     (invoice amounts come from Zoho Books and the ship date from ShipStation, via the service). */
  function sizeLabel(v){ v=String(v||''); if(/60\s*mL|2\s*oz/i.test(v)) return '60 mL (2 oz)'; if(/29\.5|1\s*oz/i.test(v)) return '29.5 mL (1 oz)'; return v; }
  function staticRow(k, v, sub){
    return '<div class="fact"><div class="k">'+esc(k)+'</div><div class="v">'+esc(v)+(sub?'<span class="sub">'+esc(sub)+'</span>':'')+'</div></div>';
  }
  // A plain <h2> picked up the theme's legacy heading font (Playfair) at display size, so the
  // sub-heading is a div styled from the form's own type tokens (Fraunces, Black).
  var PRIOR_H = '<div class="prior-h" role="heading" aria-level="2" style="font-family:var(--f-head);font-weight:600;font-size:1.15rem;line-height:1.25;color:var(--ink);margin:.35rem 0 .45rem">Prior order details</div>';
  function priorOrderBlock(ctx, isTopical){
    var po = ctx.prior_order;
    // Older service revision (no prior_order field at all): fall back to what it did send.
    if (po === undefined && (ctx.bottle_size || ctx.bottles_ordered || ctx.last_formulated))
      po = { bottle_size: ctx.bottle_size, bottles_ordered: ctx.bottles_ordered, formulated: ctx.last_formulated };
    if (!po) return PRIOR_H + ''
      + '<p class="lede" style="margin:0 0 .9rem">We do not have a completed order on file for '+esc(S.patient.name)+' yet.</p>';
    var rows = '';
    if (po.bottle_size) rows += staticRow(isTopical?'Size':'Bottle size', sizeLabel(po.bottle_size));
    if (po.bottles_ordered) rows += staticRow('Number ordered', po.bottles_ordered);
    rows += staticRow('Additional items', po.additional_items || 'None');
    if (po.formulated) rows += staticRow('Date of formulation', fmtDate(po.formulated));
    if (po.amount_product || po.amount_other) {
      rows += '<div class="fact"><div class="k">Invoiced amount</div><div class="v">'
        + (po.amount_product ? '<div>Product: '+esc(po.amount_product)+'</div>' : '')
        + (po.amount_other ? '<div>'+esc(po.amount_other_label||'Other (shipping)')+': '+esc(po.amount_other)+'</div>' : '')
        + '</div></div>';
    }
    // Ship date from ShipStation (Charles, 2026-09-22: ship date rather than delivery).
    if (po.shipped) rows += staticRow('Shipped', fmtDate(po.shipped));
    return PRIOR_H + '<div class="facts" id="facts-prior">' + rows + '</div>';
  }

  /* ---- confirm-or-correct fact row ---- */
  function factRow(entity, field, k, v, sub){
    var edited = isCorrected(entity, field);
    var current = edited ? currentValue(entity, field, v) : v;
    return '<div class="fact'+(edited?' edited':'')+'" data-e="'+entity+'" data-f="'+field+'">'
      + '<div class="k">'+esc(k)+'</div>'
      + '<div class="v">'+esc(current)+(sub?'<span class="sub">'+esc(sub)+'</span>':'')+'</div>'
      + (EDIT_META[entity+':'+field] ? '<button class="correct" data-edit="'+entity+':'+field+'">Edit</button>' : '')
      + (edited?('<div class="saved">'+CHECK+' Changed. This updates '+esc(S.patient.name)+'\u2019s record when you submit below.</div>'):'')
      + '</div>';
  }
  function currentValue(entity, field, fallback){
    var c = S.corrections.filter(function(x){return x.entity===entity&&x.field===field;})[0];
    return c ? c.to : fallback;
  }
  // Age is derived from Date_of_Birth (Patient owns it). When DOB is missing the
  // reorder fails closed per Architecture v01 \u00a77, so this renders as a required
  // capture, not a quiet correction.
  function dobBlock(){
    var dob = effectiveDOB();
    if (dob) {
      var edited = isCorrected('patient','dob');
      return '<div class="fact'+(edited?' edited':'')+'" data-e="patient" data-f="dob">'
        + '<div class="k">Age</div>'
        + '<div class="v">'+deriveAge(dob)+' years<span class="sub">Born '+esc(fmtDate(dob))+'</span></div>'
        + '<button class="correct" data-edit="patient:dob">Edit</button>'
        + (edited?('<div class="saved">'+CHECK+' Changed. This updates '+esc(S.patient.name)+'\u2019s record when you submit below.</div>'):'')
        + '</div>';
    }
    return '<div class="fact needdob" data-e="patient" data-f="dob" style="border-left:3px solid var(--crit);padding-left:.7rem;margin-left:-.7rem">'
      + '<div class="k" style="color:var(--crit)">Date of birth needed</div>'
      + '<div class="v">We don\u2019t have '+esc(S.patient.name)+'\u2019s birth date on file. We need it to formulate accurately, and it keeps '+esc(S.patient.name)+'\u2019s record complete.</div>'
      + '<button class="correct" data-edit="patient:dob" style="border-color:var(--crit);color:var(--crit)">Add</button>'
      + '</div>';
  }

  function renderNotYourPet(){
    var name = S.patient.name;
    h('<div class="card"><div class="card-h"><div class="eyebrow">Reorder</div>'
      + '<h1 class="title">Let\u2019s make sure we have the right pet</h1>'
      + '<p class="lede">We don\u2019t want to reorder the wrong formula. You can look up every pet on your account with your email, or call and we\u2019ll sort it out. Your link stays valid.</p></div>'
      + '<div class="card-b"><button class="cta" id="useEmail">Look up my pets by email</button>'
      + '<button class="linkback" id="backToPet">Actually, this is ' + esc(name) + '</button>'
      + '<p class="muted-note" style="margin-top:.6rem">Or call 310-600-7347 (7 days, 8-8pm PT).</p></div></div>');
    document.getElementById('useEmail').onclick = startCold;
    document.getElementById('backToPet').onclick = renderConfirm;
  }
  function vetCard(){
    var v = S.vet || {}, pn = (S.patient && S.patient.name) || 'your pet', body;
    if (S._vetNew){
      body = '<div class="help" style="margin-bottom:.5rem">Enter your vet\u2019s details and we\u2019ll add them. <a href="#" data-rvetpick style="color:var(--cobalt);text-decoration:underline;cursor:pointer">Search our list instead</a></div>'
        + '<label class="fld">Vet or clinic name<input id="rvetName" type="text" value="'+esc(v.name||'')+'"/></label>'
        + '<label class="fld" style="margin-top:.5rem">Clinic / hospital<input id="rvetClinic" type="text" value="'+esc(v.clinic||'')+'"/></label>';
    } else if (S._vetEdit){
      body = '<label class="fld">Search your vet or clinic<input id="rvetSearch" type="text" autocomplete="off" placeholder="Start typing a vet or clinic name\u2026"/></label><div id="rvetResults" class="vet-results"></div>'
        + '<div class="help" style="margin-top:.4rem">Can\u2019t find them? <a href="#" data-rvetnew style="color:var(--cobalt);text-decoration:underline;cursor:pointer">Add a vet not on our list</a> \u00b7 <a href="#" data-rvetcancel style="color:var(--faint);text-decoration:underline;cursor:pointer">cancel</a></div>';
    } else {
      var cur = v.name ? (esc(v.name) + (v.clinic ? ' - '+esc(v.clinic) : '')) : 'No vet on file';
      body = '<div class="q" style="font-weight:600">'+cur+(v.changed?' <span style="color:var(--cobalt);font-weight:500">(updated)</span>':'')+'</div>'
        + '<div class="help" style="margin-top:.35rem">Is this still '+esc(pn)+'\u2019s vet? <a href="#" data-rvetchange style="color:var(--cobalt);text-decoration:underline;cursor:pointer">Change or add a vet</a></div>';
    }
    return '<div class="card"><div class="card-h"><div class="eyebrow">Your vet</div></div><div class="card-b">'+body+'</div></div>';
  }
  function wireVet(){
    var ch = screenEl.querySelector('[data-rvetchange]'); if (ch) ch.onclick = function(e){ e.preventDefault(); S._vetEdit=true; S._vetNew=false; renderConfirm(); };
    var nw = screenEl.querySelector('[data-rvetnew]'); if (nw) nw.onclick = function(e){ e.preventDefault(); S._vetNew=true; S._vetEdit=false; renderConfirm(); };
    var pk = screenEl.querySelector('[data-rvetpick]'); if (pk) pk.onclick = function(e){ e.preventDefault(); S._vetNew=false; S._vetEdit=true; renderConfirm(); };
    var cx = screenEl.querySelector('[data-rvetcancel]'); if (cx) cx.onclick = function(e){ e.preventDefault(); S._vetEdit=false; S._vetNew=false; renderConfirm(); };
    var nn = document.getElementById('rvetName'); if (nn) nn.oninput = function(){ S.vet=S.vet||{}; S.vet.name=nn.value; S.vet.isNew=true; S.vet.contactId=''; S.vet.accountId=''; S.vet.changed=true; };
    var nc = document.getElementById('rvetClinic'); if (nc) nc.oninput = function(){ S.vet=S.vet||{}; S.vet.clinic=nc.value; S.vet.isNew=true; S.vet.changed=true; };
    var si = document.getElementById('rvetSearch');
    if (si){
      var box = document.getElementById('rvetResults'), tmr=null;
      var draw = function(list){
        if(!box) return;
        if(!list||!list.length){ box.innerHTML=''; return; }
        box.innerHTML = list.slice(0,12).map(function(o){
          return '<button type="button" class="vet-opt" data-ci="'+esc(o.ci)+'" data-ai="'+esc(o.ai||'')+'" data-vn="'+esc(o.v)+'" data-cn="'+esc(o.c||'')+'">'+esc(o.v)+(o.c?' <span class="vet-opt-c">'+esc(o.c)+(o.s?', '+esc(o.s):'')+'</span>':'')+'</button>';
        }).join('');
        Array.prototype.forEach.call(box.querySelectorAll('.vet-opt'), function(b){
          b.onclick = function(){ S.vet={contactId:b.getAttribute('data-ci'),accountId:b.getAttribute('data-ai'),name:b.getAttribute('data-vn'),clinic:b.getAttribute('data-cn'),isNew:false,changed:true}; S._vetEdit=false; S._vetNew=false; renderConfirm(); };
        });
      };
      si.oninput = function(){ var q=(si.value||'').trim(); if(tmr)clearTimeout(tmr); if(q.length<2){draw([]);return;} tmr=setTimeout(function(){ if(window.ReorderAPI&&ReorderAPI.vetSearch) ReorderAPI.vetSearch(q).then(draw).catch(function(){draw([]);}); },220); };
    }
  }
  function renderConfirm(){
    var p = S.parent, ship = S.shipping || {}, pt = S.patient, ctx = S.context;
    var loc = [ship.city, ship.state].filter(Boolean).join(', ');
    if (ship.zip) loc = (loc ? loc + ' ' : '') + ship.zip;
    var shipLine = [ship.street, ship.street2, loc].filter(Boolean).join(', ');
    var isTopical = ctx.product_type === 'topical';
    h(
      '<div class="card"><div class="card-h"><div class="eyebrow">Reorder</div>'
      + '<h1 class="title">Time for '+esc(pt.name)+'\u2019s next Custom formula</h1>'
      + '<p class="lede">Here is what we sent last time. Tell us what you need this time under This reorder, below.</p></div>'
      + '<div class="card-b">' + priorOrderBlock(ctx, isTopical)
      + '<div class="band"><div class="dot"></div><div>'+(ctx.unit_price_display?('Your '+(isTopical?'jar':'bottle')+' is '+esc(ctx.unit_price_display)+'. '):'')
        + 'We\u2019ll confirm your total, any savings you qualify for, and payment options after you place the reorder.</div></div>'
      + '</div></div>'

      + '<div class="card"><div class="card-h"><div class="eyebrow">Your details</div></div>'
      + '<div class="card-b"><div class="facts">'
        + factRow('parent','name','Name', p.first_name+' '+p.last_name)
        + factRow('parent','email','Email', p.email)
        + factRow('parent','phone','Phone', p.phone)
        + factRow('parent','comms','Updates by', p.communication_preference)
        + factRow('shipping','address','Shipping to', shipLine,
            'Edit to ship somewhere else this time, or to tell us you have moved.')
      + '</div></div></div>'

      + '<div class="card"><div class="card-h"><div class="eyebrow">Your pet</div>'
      + '<button class="linkback" id="notpet">Not '+esc(pt.name)+'? This is a different pet.</button></div>'
      + '<div class="card-b"><div class="facts">'
        + factRow('patient','name','Pet name', pt.name)
        + factRow('patient','species','Species', pt.species || 'Not on file')
        + factRow('patient','breed','Breed', pt.breed || 'Not on file')
        + factRow('patient','sex','Sex', pt.gender_combined)
        + dobBlock()
        + factRow('patient','medications','Medications', pt.medications || 'None on file')
      + '</div></div></div>'

      + vetCard()

      + '<div class="card"><div class="card-h"><div class="eyebrow">This reorder</div>'
      + ((ctx.last_observation && ctx.last_observation.note) ? '<div class="band" style="margin-top:.7rem"><div class="dot"></div><div>'+(ctx.last_formulated?('Last order '+esc(ctx.last_formulated)+': '+esc(ctx.last_dose_display||ctx.application_display||'')+'. '):'')+'You told us, "'+esc(ctx.last_observation.note)+'"</div></div>' : '')
      + '</div>'
      + '<div class="card-b" id="obs"></div></div>'

      + '<button class="cta" id="toReview">Review reorder</button>'
    );
    wireFacts();
    wireVet();
    var np = document.getElementById('notpet');
    if (np) np.onclick = function(){ try{window.scrollTo(0,0);}catch(_e){} if (S.mode === 'cold') startCold(); else renderNotYourPet(); };
    renderInstrument(document.getElementById('obs'));
    document.getElementById('toReview').onclick = function(){
      // An Edit form left open is SAVED, never discarded. Before 2026-10-05 a customer who typed a
      // change and went straight to Review lost it silently (Taz 29666: his move to Livermore was
      // dropped). Save re-renders this screen, so press the new Review button once the edit is applied.
      var openSave = screenEl.querySelector('.editor [data-save]');
      if(openSave){
        openSave.click();
        // Only continue if the save actually closed the editor (no loop if it ever fails).
        if(screenEl.querySelector('.editor')) return;
        var again = document.getElementById('toReview');
        if(again) again.click();
        return;
      }
      if(!effectiveDOB()){
        var el = screenEl.querySelector('.needdob');
        if(el){ el.scrollIntoView({behavior:'smooth', block:'center'});
          el.animate ? el.animate([{background:'color-mix(in srgb, var(--crit) 14%, transparent)'},{background:'transparent'}],{duration:1200}) : 0; }
        return;
      }
      if(!validateInstrument()) return;
      renderReview();
    };
  }

  function wireFacts(){
    Array.prototype.forEach.call(screenEl.querySelectorAll('[data-edit]'), function(btn){
      btn.onclick = function(){ openEditor(btn.closest('.fact')); };
    });
  }

  function openEditor(factEl){
    var entity = factEl.getAttribute('data-e'), field = factEl.getAttribute('data-f');
    var meta = EDIT_META[entity+':'+field];
    if(!meta){ return; }
    if (screenEl.querySelector('.editor')) return; // one at a time
    var host = document.createElement('div'); host.className = 'editor';
    host.innerHTML = meta.form(getVal(entity, field)) +
      '<div class="actions"><button class="btn primary" data-save>Save</button><button class="btn ghost" data-cancel>Cancel</button></div>';
    factEl.appendChild(host);
    factEl.querySelector('.correct').style.visibility = 'hidden';
    host.querySelector('[data-cancel]').onclick = function(){ renderConfirm(); };
    host.querySelector('[data-save]').onclick = function(){
      var res = meta.read(host);
      meta.apply(res);
      renderConfirm();
    };
  }
  function getVal(entity, field){
    var c = S.corrections.filter(function(x){return x.entity===entity&&x.field===field;})[0];
    if (c) return c.to;
    return DEFAULT_VAL(entity, field);
  }
  function DEFAULT_VAL(entity, field){
    var p=S.parent, ship=S.shipping, pt=S.patient, ctx=S.context;
    var map = {
      'parent:name':p.first_name+' '+p.last_name, 'parent:email':p.email, 'parent:phone':p.phone,
      'parent:comms':p.communication_preference,
      'shipping:address':[ship.street,ship.street2,ship.city,ship.state,ship.zip].join('|'),
      'patient:name':pt.name, 'patient:weight':pt.weight, 'patient:dob':(pt.date_of_birth||''), 'patient:medications':(pt.medications||''), 'request:bottles_ordered':S.request.bottles_ordered,
      'request:autoship':S.request.autoship?'On':'Off', 'formula:size':ctx.bottle_size
    };
    return map[entity+':'+field];
  }

  /* editor definitions: which facts are correctable and how */
  var EDIT_META = {
    'parent:name': { form:function(v){return textFld('Name', v);}, read:readText, apply:function(v){correct('parent','name',DEFAULT_VAL('parent','name'),v);} },
    'parent:email': { form:function(v){return textFld('Email', v,'email');}, read:readText, apply:function(v){correct('parent','email',DEFAULT_VAL('parent','email'),v);} },
    'parent:phone': { form:function(v){return textFld('Phone', v,'tel');}, read:readText, apply:function(v){correct('parent','phone',DEFAULT_VAL('parent','phone'),v);} },
    'parent:comms': { form:function(v){return selFld('Send updates by', v, ['Email','SMS']);}, read:readSel, apply:function(v){correct('parent','comms',DEFAULT_VAL('parent','comms'),v);} },
    'shipping:address': { form:addrForm, read:readAddr, apply:function(v){correct('shipping','address',DEFAULT_VAL('shipping','address'),v,_addrScope);} },
    'patient:name': { form:function(v){return textFld('Pet name', v);}, read:readText, apply:function(v){ if(!v) return; var o=S.patient.name; S.patient.name=v; correct('patient','name',o,v);} },
    'patient:weight': { form:function(v){return numFld('Weight (lb)', v);}, read:readText, apply:function(v){correct('patient','weight',DEFAULT_VAL('patient','weight'),v); S.observation.weight=v;} },
    'patient:medications': { form:function(v){return textareaFld('Current medications & supplements', v);}, read:readText, apply:function(v){correct('patient','medications',DEFAULT_VAL('patient','medications'),v);} },
    'patient:dob': {
      form:function(v){ return '<div class="row">'
        + '<label class="fld">Birth date<input data-in-date type="date" value="'+(v?esc(v):'')+'"/></label>'
        + '<label class="fld">Or age in years<input data-in-age type="number" inputmode="numeric" min="0" max="30" placeholder="e.g. 7"/></label></div>'
        + '<p class="help">A birth date is best. If you only know '+esc(S.patient.name)+'\u2019s age, we\u2019ll estimate the birth date from it and note that it is an estimate.</p>'; },
      read:function(host){
        var d=host.querySelector('[data-in-date]').value, a=host.querySelector('[data-in-age]').value;
        if(d) return {dob:d, basis:'Exact'};
        if(a){ var n=new Date(); var y=n.getFullYear()-parseInt(a,10);
          var iso=y+'-'+String(n.getMonth()+1).padStart(2,'0')+'-'+String(n.getDate()).padStart(2,'0');
          return {dob:iso, basis:'Derived from Age'}; }
        return null;
      },
      apply:function(res){ if(!res||!res.dob) return; var orig=S.patient.date_of_birth||'';
        S.patient.date_of_birth=res.dob; S.patient.dob_basis=res.basis; correct('patient','dob',orig,res.dob); }
    },
    'request:bottles_ordered': { form:function(v){return selFld('Bottles', v, ['1','2','3']);}, read:readSel, apply:function(v){S.request.bottles_ordered=v; correct('request','bottles_ordered',DEFAULT_VAL('request','bottles_ordered'),v);} },
    'request:autoship': { form:function(v){return selFld('Autoship', v, ['On','Off']);}, read:readSel, apply:function(v){S.request.autoship=(v==='On'); correct('request','autoship',DEFAULT_VAL('request','autoship'),v);} },
    'formula:size': { form:function(v){ var tp=S.context.product_type==='topical'; return selFld(tp?'Size':'Bottle size', v, tp?['2 oz jar','4 oz jar']:['29.5 mL (1 oz)','60 mL (2 oz)']);}, read:readSel, apply:function(v){S.request.bottle_size=v; correct('formula','size',DEFAULT_VAL('formula','size'),v);} }
  };
  function textFld(label,v,type){ return '<label class="fld">'+esc(label)+'<input data-in type="'+(type||'text')+'" value="'+esc(v)+'"/></label>'; }
  function numFld(label,v){ return '<label class="fld">'+esc(label)+'<input data-in type="number" inputmode="decimal" value="'+esc(v)+'"/></label>'; }
  function textareaFld(label,v){ return '<label class="fld">'+esc(label)+'<textarea data-in rows="3">'+esc(v)+'</textarea></label>'; }
  function selFld(label,v,opts){ return '<label class="fld">'+esc(label)+'<select data-in>'+opts.map(function(o){return '<option'+(o===String(v)?' selected':'')+'>'+esc(o)+'</option>';}).join('')+'</select></label>'; }
  /* Form audit 2026-10-18: the list held 10 states + 'Other', so an NJ or NC customer saw CA pre-selected and
     saving wrote the wrong state. Full US list; a stored value not on it is kept as the first option. */
  var US_STATES = ['AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME',
    'MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN',
    'TX','UT','VT','VA','WA','WV','WI','WY'];
  function stateVal(v){ v=String(v||'').trim(); return US_STATES.indexOf(v.toUpperCase())>=0 ? v.toUpperCase() : v; }
  function stateOpts(v){ v=stateVal(v); return (v && US_STATES.indexOf(v)<0 ? [v] : v ? [] : ['']).concat(US_STATES); }
  function readText(host){ return host.querySelector('[data-in]').value.trim(); }
  function readSel(host){ return host.querySelector('[data-in]').value; }
  var _addrScope = 'once';   // 'permanent' once the customer says they have moved
  function addrForm(v){ var a=String(v).split('|');
    var permChecked = _addrScope==='permanent' ? ' checked' : '';
    var onceChecked = _addrScope==='permanent' ? '' : ' checked';
    return '<div class="row">'+textFld('Street', a[0])+textFld('Apt / unit', a[1])+'</div>'
      + '<div class="row">'+textFld('City', a[2])+selFld('State', stateVal(a[3]), stateOpts(a[3]))+textFld('ZIP', a[4])+'</div>'
      + '<div class="row" data-addr-scope>'
      + '<label class="fld"><input type="radio" name="addr-scope" value="once"'+onceChecked+'/> Ship here just this once</label>'
      + '<label class="fld"><input type="radio" name="addr-scope" value="permanent"'+permChecked+'/> I\u2019ve moved - update my address</label>'
      + '</div>'
      + '<p class="help">Tell us if this is a move and we\u2019ll update the address on your record, so you won\u2019t have to change it again next time.</p>'; }
  function readAddr(host){ var ins=host.querySelectorAll('[data-in]');
    var sc = host.querySelector('input[name="addr-scope"]:checked');
    _addrScope = sc ? sc.value : 'once';
    return [ins[0].value,ins[1].value,ins[2].value,ins[3].value,ins[4].value].join('|'); }

  /* Keep the order lines honest when a product is unticked: drop the answers that
     belonged to it, so a removed Topical Balm cannot leave a quantity behind. And
     when no Custom tincture is on the order, Bottles_Ordered still has to say so -
     'None - Topical or booster only' is a real value on that picklist. */
  var ORDER_LINES = {
    'Custom Tincture':['tincture_qty','tincture_size','tincture_mixed','tincture_details'],
    'Topical Balm'   :['topical_qty'],
    'Booster'        :['booster_qty','booster_size','booster_details'],
    'Hemp Products'  :['hemp_product','hemp_qty','addon_for']
  };
  function syncOrderLines(){
    var on = S.observation.reorder_types || [];
    for (var t in ORDER_LINES){
      if (!ORDER_LINES.hasOwnProperty(t) || on.indexOf(t) !== -1) continue;
      ORDER_LINES[t].forEach(function(k){ delete S.observation[k]; });
    }
    if (on.indexOf('Custom Tincture') === -1) S.observation.tincture_qty = 'None - Topical or booster only';
    else {
      if (S.observation.tincture_qty === 'None - Topical or booster only') delete S.observation.tincture_qty;
      var pf = S._orderPrefill || {};                       // restore the last order's values
      for (var pk in pf) if (pf.hasOwnProperty(pk) && !S.observation[pk]) S.observation[pk] = pf[pk];
    }
  }

  /* ---- instrument (Observation) ---- */
  function renderInstrument(host){
    var html = INSTRUMENT.fields.map(function(f){
      if (f.orderField && S._checkin) return '';
      // a trigger may be a single value or a multi-select array (reorder_types)
      if (f.requiredWhen){ var rk=Object.keys(f.requiredWhen)[0], rv=S.observation[rk], want=f.requiredWhen[rk];
        var hit = (Object.prototype.toString.call(rv)==='[object Array]') ? rv.indexOf(want)!==-1 : rv===want;
        if(!hit) return ''; }
      return fieldHtml(f);
    }).join('');
    host.innerHTML = html;
    // number
    var w = host.querySelector('[data-obs="weight"]'); if(w){ w.value = S.observation.weight||''; w.oninput=function(){ S.observation.weight=w.value; }; }
    Array.prototype.forEach.call(host.querySelectorAll('textarea[data-obs], input[type="text"][data-obs]'), function(t){
      var k=t.getAttribute('data-obs'); t.value=S.observation[k]||''; t.oninput=function(){ S.observation[k]=t.value; };
    });
    Array.prototype.forEach.call(host.querySelectorAll('.choice[data-k]'), function(c){
      c.onclick = function(){
        var k=c.getAttribute('data-k'), v=c.getAttribute('data-v');
        S.observation[k]=v;
        renderInstrument(host);
      };
    });
    // condition checklist: toggling reveals or hides that condition\u2019s battery
    Array.prototype.forEach.call(host.querySelectorAll('.choice[data-cond]'), function(c){
      c.onclick = function(){
        var k = c.getAttribute('data-cond');
        var on = S.observation.conditions || (S.observation.conditions = []);
        var at = on.indexOf(k);
        if (at === -1) on.push(k);
        else {
          on.splice(at,1);
          (RR_BATTERY[k]||[]).forEach(function(m){ delete S.observation.pro[m.key]; });
          if (RR_COND_NOTES[k]) delete S.observation[RR_COND_NOTES[k].key];
        }
        renderInstrument(host);
      };
    });
    // clinical sliders, 0-5 where 0 is none and 5 is worst
    Array.prototype.forEach.call(host.querySelectorAll('.scale[data-slider]'), function(b){
      b.onclick = function(){
        S.observation.pro = S.observation.pro || {};
        S.observation.pro[b.getAttribute('data-slider')] = Number(b.getAttribute('data-val'));
        Array.prototype.forEach.call(host.querySelectorAll('.scale[data-slider="'+b.getAttribute('data-slider')+'"]'), function(x){ x.classList.remove('sel'); });
        b.classList.add('sel');
        var mh=b.closest('.field'); if(mh) mh.classList.remove('missing');
      };
    });
    Array.prototype.forEach.call(host.querySelectorAll('select[data-sel]'), function(sl){
      sl.onchange = function(){ S.observation[sl.getAttribute('data-sel')] = sl.value;
        var mh=sl.closest('.field'); if(mh) mh.classList.remove('missing'); };
    });
    Array.prototype.forEach.call(host.querySelectorAll('.choice[data-multi]'), function(c){
      c.onclick = function(){
        var k=c.getAttribute('data-multi'), v=c.getAttribute('data-v');
        var arr = S.observation[k] || (S.observation[k]=[]);
        var at = arr.indexOf(v);
        if (at===-1) arr.push(v); else arr.splice(at,1);
        var mh=c.closest('.field'); if(mh) mh.classList.remove('missing');
        if (k==='reorder_types'){ syncOrderLines(); renderInstrument(host); return; }
        c.classList.toggle('sel');
      };
    });
    /* legacy .scale[data-dom] handler removed 2026-09-24 - superseded by
       .scale[data-slider]; nothing renders data-dom since the v2 instrument. */
  }
  /* Condition checklist + the full battery for every ticked condition.
     Every clinical slider is 0-5 (0 = none) where 5 is WORST, with its anchors printed beneath
     the question exactly as the spec writes them. Ticking a condition reveals its
     battery immediately; unticking hides it and drops its answers. */
  /* What a 0 means, per measure (wording approved by Charles 2026-10-16). Shown as its own
     line ABOVE the spec anchors, which stay verbatim. */
  var RR_ZERO = {
    Mobility_Overall:'0 means no mobility restriction', Mobility_Prevent_Activity:'0 means no mobility restriction',
    Mobility_Pain:'0 means no mobility restriction',
    Pain_Overall:'0 means no signs of discomfort', Pain_Prevent_Activities:'0 means no signs of discomfort',
    Pain_Daily_Comfort:'0 means no signs of discomfort',
    Anxiety_Overall:'0 means no signs of anxiety', Anxiety_Trigger_Human:'0 means no signs of anxiety',
    Anxiety_Trigger_Events:'0 means no signs of anxiety',
    Seizures_Frequency:'0 means no seizure activity since last order', Seizures_Length:'0 means no seizure activity since last order',
    Seizures_Postictal:'0 means no seizure activity since last order',
    Cancer_Slider:'0 means no impact of the disease on quality of life now, such as remission.',
    GI_Inflammation:'0 means no digestive upset', Appetite:'0 means appetite is normal'
  };
  function sliderRowHtml(m){
    var sel = S.observation.pro[m.key];
    var scale = [0,1,2,3,4,5].map(function(n){
      return '<button type="button" class="choice scale'+(sel===n?' sel':'')+'" data-slider="'+esc(m.key)+'" data-val="'+n+'">'+n+'</button>';
    }).join('');
    return '<div class="field"><div class="q">'+esc(m.q)+' <span class="req">*</span></div>'
      + (RR_ZERO[m.key] ? '<div class="help">'+esc(RR_ZERO[m.key])+'</div>' : '')
      + (m.a ? '<div class="help">'+esc(m.a)+'</div>' : '')
      + '<div class="choices">'+scale+'</div></div>';
  }
  function renderInstrumentHtml(){
    S.observation.pro = S.observation.pro || {};
    var on = S.observation.conditions || [];
    var ticks = RR_CONDITIONS.map(function(c){
      var isOn = on.indexOf(c.key) !== -1;
      return '<button type="button" class="choice'+(isOn?' sel':'')+'" data-cond="'+esc(c.key)+'">'+esc(c.label)+'</button>';
    }).join('');
    var html = '<div class="field"><div class="q">What are we formulating for '+esc(S.patient.name)+'? <span class="req">*</span></div>'
      + '<div class="help">Tick everything that applies. Add or remove any of these at any time - we will ask the matching questions.</div>'
      + '<div class="choices">'+ticks+'</div></div>';
    RR_CONDITIONS.forEach(function(c){
      if (on.indexOf(c.key) === -1) return;
      var battery = RR_BATTERY[c.key] || [];
      var note = RR_COND_NOTES[c.key];
      if (!battery.length && !note) return;
      html += '<div class="band" style="display:block;margin-top:14px"><b>'+esc(c.label)+'</b></div>';
      battery.forEach(function(m){ html += sliderRowHtml(m); });
      if (note){
        html += '<div class="field"><div class="q">'+esc(note.label)+'</div>'
             +  '<textarea data-obs="'+esc(note.key)+'"></textarea></div>';
      }
    });
    return html;
  }
  function fieldHtml(f){
    if (f.type==='instrument') return renderInstrumentHtml();
    var q = fill(f.label), help = f.help?'<div class="help">'+fill(f.help)+'</div>':'';
    // optional:true = revealed by its trigger but not required, so no asterisk.
    var rq = (f.required || (f.requiredWhen && !f.optional)) ? ' <span class="req">*</span>' : '';
    if (f.type==='number'){
      var lo = (S.context && S.context.last_observation) || null;
      var lastLine = (lo && lo.weight!=null && lo.weight!=='') ? ('Last reported '+(lo.date?'on '+esc(fmtDate(lo.date))+' ':'')+'as '+esc(lo.weight)+' lb. ') : '';
      return '<div class="field"><div class="q">Current weight'+rq+'</div>'
        + '<div class="help">'+lastLine+'Enter '+esc(S.patient.name)+'\u2019s weight today. An estimate is fine.</div>'
        /* The last weight is already stated in the help line above, so it must NOT also be
           the placeholder: a grey 142 in an empty required field reads as a filled one
           (Cathy, 24 Sep). min/step give the steppers a floor; the CSS hides them. */
        + '<div class="weightrow"><input data-obs="weight" type="number" inputmode="decimal" min="0.5" max="2500" step="0.1" style="width:6.5rem" placeholder="Weight in lb"/><span class="unit">'+esc(f.unit)+'</span></div></div>';
    }
    if (f.type==='textarea'){
      return '<div class="field"><div class="q">'+esc(q)+rq+'</div>'+help
        + '<textarea data-obs="'+f.key+'" placeholder="'+esc(f.placeholder||'')+'"></textarea></div>';
    }
    if (f.type==='text'){
      return '<div class="field"><div class="q">'+esc(q)+rq+'</div>'+help
        + '<input data-obs="'+f.key+'" type="text" maxlength="60" placeholder="'+esc(f.placeholder||'')+'"/></div>';
    }
    if (f.type==='select'){
      var cur = S.observation[f.key] || '';
      var os = ['<option value="">Please choose</option>'].concat((f.options||[]).map(function(o){
        var v = (typeof o==='string') ? o : o.value, l = (typeof o==='string') ? o : o.label;
        return '<option value="'+esc(v)+'"'+(cur===v?' selected':'')+'>'+esc(l)+'</option>';
      })).join('');
      return '<div class="field"><div class="q">'+esc(q)+rq+'</div>'+help
        + '<select data-sel="'+f.key+'">'+os+'</select></div>';
    }
    if (f.type==='multi'){
      var picked = S.observation[f.key] || [];
      var boxes = (f.options||[]).map(function(o){
        return '<button type="button" class="choice'+(picked.indexOf(o.value)!==-1?' sel':'')+'" data-multi="'+f.key+'" data-v="'+esc(o.value)+'">'+esc(fill(o.label))+'</button>';
      }).join('');
      return '<div class="field"><div class="q">'+esc(q)+rq+'</div>'+help+'<div class="choices">'+boxes+'</div></div>';
    }
    var sel = S.observation[f.key];
    var opts = (typeof f.options === 'function') ? f.options(S) : f.options;
    var choices = opts.map(function(o){
      return '<button type="button" class="choice'+(sel===o.value?' sel':'')+'" data-k="'+f.key+'" data-v="'+o.value+'">'+esc(fill(o.label))+'</button>';
    }).join('');
    return '<div class="field"><div class="q">'+esc(q)+rq+'</div>'+help+'<div class="choices">'+choices+'</div></div>';
  }
  function validateInstrument(){
    var missing = [];
    if(!S.observation.formula_intent) missing.push('same or changed formula');
    if(S.observation.formula_intent==='changed' && !S.observation.formula_change_note) missing.push('what changed');
    /* Truthiness let "-1" through and rejected a real "0". Weight drives the dose. */
    var wNum = parseFloat(S.observation.weight);
    if(S.observation.weight === '' || S.observation.weight == null || !isFinite(wNum)) missing.push('weight');
    else if(wNum <= 0) missing.push('a weight above zero');
    else if(wNum > 2500) missing.push('a weight under 2500 lb');
    if(!S.observation.current_dose) missing.push('dose per serving');
    S.observation.pro=S.observation.pro||{};
    var on=S.observation.conditions||[];
    if(!on.length) missing.push('what we are formulating for');
    // every measure of every ticked condition is required (spec s2, s8)
    var firstMissingSlider=null;
    on.forEach(function(ck){
      (RR_BATTERY[ck]||[]).forEach(function(m){
        if(S.observation.pro[m.key]==null){   // 0 is a real answer (none) - Gail/Luc 2026-10-16
          if(!firstMissingSlider) firstMissingSlider=m.key;
          var cl=(RR_CONDITIONS.filter(function(c){return c.key===ck;})[0]||{}).label||ck;
          if(missing.indexOf(String(cl).toLowerCase())===-1) missing.push(String(cl).toLowerCase());
        }
      });
    });
    if(!S.observation.side_effects_since_last_order) missing.push('side effects');
    if(S.observation.side_effects_since_last_order==='some' && !S.observation.side_effect_details) missing.push('side effect details');
    if(!S.observation.overall_response) missing.push('overall response');
    if(!S.observation.new_meds) missing.push('new medications');
    if(S.observation.new_meds==='yes' && !S.observation.new_meds_list) missing.push('which medications');
    if(!S.observation.new_vet) missing.push('new vet');
    if(S.observation.new_vet==='yes' && !S.observation.new_vet_name) missing.push('which practice');
    if(!S._checkin){
      if(!(S.observation.reorder_types||[]).length) missing.push('what you need to reorder');
      if(!S.observation.payment_option) missing.push('payment method');
      // every revealed order line must be complete. "Who is it for" stays optional.
      var picked = S.observation.reorder_types || [];
      if(picked.indexOf('Custom Tincture')!==-1){
        if(!S.observation.tincture_qty) missing.push('how many Custom tincture bottles');
        if(!S.observation.tincture_size) missing.push('Custom tincture bottle size');
        if(!S.observation.tincture_mixed) missing.push('whether the bottles differ');
        if(S.observation.tincture_mixed==='yes' && !S.observation.tincture_details) missing.push('what you need on each bottle');
      }
      if(picked.indexOf('Topical Balm')!==-1 && !S.observation.topical_qty) missing.push('how many Topical Balm jars');
      if(picked.indexOf('Booster')!==-1){
        if(!S.observation.booster_qty) missing.push('how many Boosters');
        if(!S.observation.booster_size) missing.push('Booster bottle size');
      }
      if(picked.indexOf('Hemp Products')!==-1){
        if(!S.observation.hemp_product) missing.push('which Formulary formula');
        if(!S.observation.hemp_qty) missing.push('how many Formulary bottles');
      }
    }
    if(missing.length){
      var host = document.getElementById('obs');
      var warn = document.getElementById('obs-warn');
      if(!warn){ warn=document.createElement('div'); warn.id='obs-warn'; warn.className='band';
        warn.style.color='var(--crit)'; warn.style.borderColor='var(--crit)'; host.appendChild(warn); }
      warn.innerHTML='<div class="dot" style="background:var(--crit)"></div><div>Please answer the check-in questions ('+missing.join(', ')+') so we can formulate correctly.</div>';
      var jumpSel=null;
      if(!S.observation.formula_intent) jumpSel='[data-k="formula_intent"]';
      else if(S.observation.formula_intent==='changed' && !S.observation.formula_change_note) jumpSel='[data-obs="formula_change_note"]';
      else if(!S.observation.weight) jumpSel='[data-obs="weight"]';
      else { if(!S.observation.current_dose) jumpSel='[data-sel="current_dose"]';
        else if(!(S.observation.conditions||[]).length) jumpSel='[data-cond]';
        else if(firstMissingSlider) jumpSel='[data-slider="'+firstMissingSlider+'"]';
        if(!jumpSel){ if(!S.observation.side_effects_since_last_order) jumpSel='[data-k="side_effects_since_last_order"]';
          else if(S.observation.side_effects_since_last_order==='some' && !S.observation.side_effect_details) jumpSel='[data-obs="side_effect_details"]';
          else if(!S.observation.overall_response) jumpSel='[data-k="overall_response"]';
          else if(!S._checkin && !(S.observation.reorder_types||[]).length) jumpSel='[data-multi="reorder_types"]';
          else if(!S._checkin && !S.observation.tincture_qty) jumpSel='[data-k="tincture_qty"]';
          else if(!S._checkin && !S.observation.tincture_size) jumpSel='[data-k="tincture_size"]';
          else if(!S._checkin && !S.observation.payment_option) jumpSel='[data-k="payment_option"]';
          else if(!S._checkin && (S.observation.reorder_types||[]).indexOf('Hemp Products')!==-1 && !S.observation.hemp_product) jumpSel='[data-k="hemp_product"]'; } }
      var fe = jumpSel ? host.querySelector(jumpSel) : null;
      if(fe){ var mh=fe.closest('.field')||fe; fe.scrollIntoView({behavior:'smooth',block:'center'}); try{fe.focus({preventScroll:true});}catch(_e){} mh.classList.add('missing'); setTimeout(function(){mh.classList.remove('missing');},2200); }
      else { warn.scrollIntoView({behavior:'smooth', block:'center'}); }
      return false;
    }
    if(!S._checkin){
      var szLabel = S.observation.tincture_size === 'New - 2 oz (60 mL) with 10% off' ? '60 mL (2 oz)'
                  : S.observation.tincture_size === 'Standard 1 oz (29.5 mL)' ? '29.5 mL (1 oz)'
                  : (S.observation.tincture_size || '');
      S.request.bottle_size = S.observation.tincture_size || '';
      S.request.bottles_ordered = S.observation.tincture_qty || '';
      /* One entry per product actually ordered, each carrying its own quantity and
         size, so a tincture-plus-balm order is unambiguous in the record. The two
         fields above stay for the existing server mapping. */
      var picked = S.observation.reorder_types || [];
      S.request.lines = {
        tincture: picked.indexOf('Custom Tincture') !== -1
          ? { qty:S.observation.tincture_qty, size:S.observation.tincture_size,
              mixed:S.observation.tincture_mixed === 'yes',
              details:(S.observation.tincture_details || '').trim() } : null,
        topical: picked.indexOf('Topical Balm') !== -1
          ? { qty:S.observation.topical_qty } : null,
        booster: picked.indexOf('Booster') !== -1
          ? { qty:S.observation.booster_qty, size:S.observation.booster_size,
              details:(S.observation.booster_details || '').trim() } : null,
        formulary: picked.indexOf('Hemp Products') !== -1 && S.observation.hemp_product
          ? { product:S.observation.hemp_product, qty:S.observation.hemp_qty || '1',
              for_pet:(S.observation.addon_for || '').trim() } : null
      };
      S.request.payment_option = S.observation.payment_option;
      if (S.observation.order_autoship) {
        var wantAuto = S.observation.order_autoship === 'On';
        if (wantAuto !== !!S.context.autoship) correct('request','autoship', S.context.autoship ? 'On' : 'Off', S.observation.order_autoship);
        S.request.autoship = wantAuto;
      }
      correct('formula','size', sizeLabel(S.context.bottle_size), szLabel);                       // review screen shows the confirmed size
      correct('request','bottles_ordered', S.context.bottles_ordered, S.observation.tincture_qty);
      // Formulary add-on for a second pet. Sent only when asked for, so an order
      // that does not want one carries nothing at all (2026-09-20).
      S.request.addon = S.request.lines.formulary;
    }
    return true;
  }

  /* ---- review ---- */
  function renderReview(){
    var pt=S.patient, ctx=S.context, ship=S.shipping;
    var isTopical = ctx.product_type === 'topical';
    var shipLine = currentValue('shipping','address', [ship.street,ship.street2,ship.city,ship.state,ship.zip].join('|'));
    shipLine = shipLine.split('|').filter(Boolean).join(', ');
    var pro = S.observation.pro || {};
    var proSummary = (S.observation.conditions||[]).map(function(ck){
      var cl=(RR_CONDITIONS.filter(function(c){return c.key===ck;})[0]||{}).label||ck;
      var vals=(RR_BATTERY[ck]||[]).map(function(m){ return (pro[m.key]==null?'\u2014':pro[m.key])+'/5'; });
      return vals.length ? cl+' '+vals.join(', ') : cl;
    }).join(' \u00b7 ');
    var se = S.observation.side_effects_since_last_order==='some' ? 'Some - '+esc(S.observation.side_effect_details||'') : 'None';
    h('<div class="steps"><div class="s done"></div><div class="s done"></div></div>'
      + '<div class="card"><div class="card-h"><div class="eyebrow">Review</div>'
      + '<h1 class="title">Ready to place '+esc(pt.name)+'\u2019s reorder</h1>'
      + '<p class="lede">Please confirm the details below. We\u2019ll formulate on the next Monday or Wednesday and email tracking.</p></div>'
      + '<div class="card-b"><div class="facts summ">'
        + factRow('formula','display','Formula', ctx.formula_display)
        + '<div class="fact"><div class="k">Formula request</div><div class="v">'+(S.observation.formula_intent==='changed'?'Change noted for our team to review':'Same formula as last time')+'</div></div>'
        + (function(){var bs=sizeLabel(currentValue('formula','size',ctx.bottle_size)),bc=currentValue('request','bottles_ordered',S.request.bottles_ordered),unit=(isTopical?'jar(s)':'bottle(s)'),parts=[];if(bs!=null&&bs!=='')parts.push(esc(bs));if(bc!=null&&bc!=='')parts.push(esc(bc)+' '+unit);return '<div class="fact"><div class="k">'+(isTopical?'Jar':'Bottle')+'</div><div class="v">'+(parts.join(' \u00b7 ')||'To be confirmed')+'</div></div>';})()
        + '<div class="fact"><div class="k">Autoship</div><div class="v">'+(S.request.autoship?'On':'Off')+'</div></div>'
        // Shown only when a Formulary bottle was added, so the customer can see it
        // was captured before they submit (2026-09-20).
        + (function(){ var a=S.request.addon; if(!a) return '';
            return '<div class="fact"><div class="k">Also adding</div><div class="v">'
              + esc(a.product)+' x '+esc(a.qty)+(a.for_pet?' for '+esc(a.for_pet):'')
              + '<br><span class="muted-note">Right:Ratio Formulary, on the same invoice</span></div></div>'; })()
        + '<div class="fact"><div class="k">Payment</div><div class="v">'+esc(S.request.payment_option||'')+'</div></div>'
        + '<div class="fact"><div class="k">Ship to</div><div class="v">'+esc(shipLine)+'</div></div>'
        + '<div class="fact"><div class="k">Weight now</div><div class="v">'+esc(S.observation.weight)+' lb</div></div>'
        + '<div class="fact"><div class="k">How '+esc(pt.name)+' is doing</div><div class="v">'+esc(proSummary||'\u2014')+'</div></div>'
        + '<div class="fact"><div class="k">Side effects</div><div class="v">'+se+'</div></div>'
      + '</div>'
      + (S.corrections.length?'<div class="band"><div class="dot"></div><div>'+S.corrections.length+' correction(s) will be saved to '+esc(pt.name)+'\u2019s record before we formulate.</div></div>':'')
      + '<div class="price" style="margin-top:.9rem"><span class="lede" style="margin:0">Bottle price</span><span class="amt">'+esc(ctx.unit_price_display||'To be confirmed')+'</span></div>'
      + '<div class="band"><div class="dot"></div><div>This is the per-bottle price. After you place the reorder, our team reviews '+esc(pt.name)+'\u2019s check-in and sends your invoice with the final total, payment options, and any dosing guidance.</div></div>'
      + '<button class="cta" id="place">Place reorder</button>'
      + '<button class="linkback" id="backConfirm">Go back and edit</button>'
      + '</div></div>');
    document.getElementById('backConfirm').onclick = renderConfirm;
    document.getElementById('place').onclick = function(){
      var btn=this; btn.setAttribute('disabled','disabled'); btn.textContent='Placing reorder...';
      S._forceSubmitError = forceErr;
      ReorderAPI.submitReorder(S).then(function(r){ _petSet(null); if(ReorderAPI.clearSession) ReorderAPI.clearSession(); goDone(r); },
        function(err){
          if(_expired(err)){ var keep = S; startCold(); S._resume = keep;
            return renderColdEmail('For your security, please confirm your email again. Your answers are saved.'); }
          renderSubmitError(renderReview);
        });
    };
  }

  /* Success only. The confirmation now lives on /pages/custom-reorder-submitted so the
     GA4 rule (page_view whose page_location contains custom-reorder-submitted) can match -
     it never could while this screen painted in place. The pet name travels in
     sessionStorage, NEVER in the URL: the pixel sends page_location to Google. The only
     thing in the query string is the Zoho order number, the join key back to the order.
     If anything here throws we fall through to renderDone() and the customer still sees a
     confirmation - analytics must never cost someone their receipt. (2026-09-26) */
  function goDone(r){
    var pt = S.patient || {};
    try {
      sessionStorage.setItem('rr_confirm', JSON.stringify({
        kind: 'reorder',
        pet: pt.name || '',
        comm: (S.parent && S.parent.communication_preference) || 'Email'
      }));
    } catch(e){}
    try {
      var on = r && r.order_number;
      window.location.assign('/pages/custom-reorder-submitted' + (on ? '?o=' + encodeURIComponent(on) : ''));
      return;
    } catch(e){}
    renderDone();
  }

  function renderDone(){
    var pt=S.patient;
    h('<div class="card"><div class="center"><div class="icon-badge good">'+CHECK+'</div>'
      + '<h1 class="title">'+esc(pt.name)+'\u2019s reorder is in</h1>'
      + '<p class="lede" style="max-width:28rem;margin-left:auto;margin-right:auto">A member of our team reviews every reorder before we formulate. Your invoice will follow by '
      + (S.parent.communication_preference==='SMS'?'text':'email')+' with your total, payment options, and any dosing guidance for '+esc(pt.name)+'. We formulate on the next Monday or Wednesday and send tracking once it ships.</p>'
      + '<p class="muted-note" style="margin-top:1rem">Questions in the meantime, call 310-600-7347 (7 days, 8-8pm PT).</p>'
      + '</div></div>');
  }

  /* ---- Mode C: check-in only ---- */
  function renderCheckIn(){
    var pt=S.patient, ctx=S.context, ship=S.shipping;
    var shipLine=[ship.street,ship.street2,ship.city+', '+ship.state+' '+ship.zip].filter(Boolean).join(', ');
    h('<div class="card"><div class="card-h"><div class="eyebrow">Autoship check-in</div>'
      + '<div class="hold" style="margin:.2rem 0 .7rem">'+CHECK.replace('stroke-width="2.4"','stroke-width="2"')+' Shipment on hold</div>'
      + '<h1 class="title">How is '+esc(pt.name)+' doing?</h1>'
      /* No hold reason is ever shown to a customer (CL, 2026-09-25). The service never
         sent that key, so this read had always rendered an empty string anyway. */
      + '<p class="lede">This check-in does not place an order. Once you answer, we\u2019ll release the next shipment.</p></div>'
      + '<div class="card-b" id="obs"></div></div>'

      + '<div class="card"><div class="card-h"><div class="eyebrow">Shipping to</div></div>'
      + '<div class="card-b"><div class="facts">'
        + factRow('shipping','address','Address', shipLine)
      + '</div></div></div>'

      + '<button class="cta" id="submitCheckin">Submit check-in</button>');
    wireFacts();
    var host=document.getElementById('obs');
    // check-in instrument reuses the same fields, minus the order questions
    S._checkin = true;
    renderInstrument(host);
    document.getElementById('submitCheckin').onclick=function(){
      if(!validateInstrument()) return;
      var btn=this; btn.setAttribute('disabled','disabled'); btn.textContent='Submitting...';
      S._forceSubmitError=forceErr;
      ReorderAPI.submitCheckIn(S).then(function(){ _petSet(null); renderCheckInDone(); },
        function(err){ if(_expired(err)) return startCold('For your security, please confirm your email again.'); renderSubmitError(renderCheckIn); });
    };
  }
  function renderCheckInDone(){
    var pt=S.patient;
    h('<div class="card"><div class="center"><div class="icon-badge good">'+CHECK+'</div>'
      + '<h1 class="title">Thank you</h1>'
      + '<p class="lede" style="max-width:26rem;margin:.4rem auto 0">We\u2019ve released '+esc(pt.name)+'\u2019s next shipment. You\u2019ll get tracking by '+(S.parent.communication_preference==='SMS'?'text':'email')+' when it goes out.</p>'
      + '</div></div>');
  }

  function renderSubmitError(retry){
    var card=document.createElement('div'); card.className='card';
    card.innerHTML='<div class="card-b"><div class="band" style="color:var(--crit);border-color:var(--crit)">'
      + '<div class="dot" style="background:var(--crit)"></div><div><b>We couldn\u2019t submit that.</b> Nothing was sent and nothing changed. Please try again. If it keeps happening, call 310-600-7347.</div></div>'
      + '<button class="cta" id="retry">Try again</button></div>';
    screenEl.appendChild(card);
    document.getElementById('retry').onclick=function(){ forceErr=false; retry(); };
    card.scrollIntoView({behavior:'smooth', block:'center'});
  }

  // boot: if this tab already confirmed its email and picked a pet, a refresh resumes
  // that pet instead of starting over at the email step (2026-09-19). Otherwise the
  // primary path: cold arrival (email, six-digit code, reorder/intake).
  (function(){
    var pid = _petGet();
    if(pid && ReorderAPI.hasSession && ReorderAPI.hasSession()){ newSession('cold'); loadPet(pid); }
    else startCold();
  })();
})();